// Angular
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
// Layout
import { LayoutConfigService } from '@core/_base/layout';
// Object-Path
import objectPath from 'object-path';
import { Observable } from 'rxjs';
import { TbTipoCambio } from '~models/maestros/TbTipoCambio';
import { TbTipoCambioService } from '~core/service/maestros-sync/tbTipoCambio.service';

@Component({
	selector: 'kt-footer',
	templateUrl: './footer.component.html',
	host: {
		class: 'kt-footer',
	},
	encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements OnInit {
	// Public properties
	today: number = Date.now();
	fluid!: boolean;
	tipoCambio$!: Observable<TbTipoCambio>;

	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayouConfigService
	 * @param tbTipoCambioService: TbTipoCambioService
	 */
	constructor(private layoutConfigService: LayoutConfigService, private tbTipoCambioService: TbTipoCambioService) {}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		const config = this.layoutConfigService.getConfig();

		// footer width fluid
		this.fluid = objectPath.get(config, 'footer.self.width') === 'fluid';

		// Tipo de cambio del día
		this.tipoCambio$ = this.tbTipoCambioService.findLatestByMonedaAndFchCambio('USD', 'PEN', new Date());
	}
}
